import React, {PureComponent} from 'react';
import {Select,Form} from 'antd';
import {RTLCol, RTLSelect} from '../RTLKit';


export default class SelectFieldForLoadCity extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }


    onChange(val, opt) {
        const {input} = this.props;
        input.onChange(val);
    }


    render() {

        const {
            input,
            label,
            mode,
            iconName,
            placeholder,
            defaultValue,
            meta: {touched, error, warning},
        } = this.props;
        const {Option} = Select;

        let value = defaultValue
        if(input.value)
            value = input.value

        return (
            <div>
                <RTLCol span={24}>
                    <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                        {label ? <label>{label} : </label> : null}
                    </RTLCol>
                    <RTLCol md={label ? 15 : 19} sm={24}>
                        <Form.Item hasFeedback validateStatus={(touched && error) ? 'error' : ''}>
                            <RTLSelect onChange={this.onChange.bind(this)}
                                       mode={mode}
                                       value={value}
                                       placeholder={placeholder}
                            >
                                {this.props.list.map((item, index) => {
                                    return (<Option key={index} value={item.value}>{item.label}</Option>)
                                })}
                            </RTLSelect>
                        </Form.Item>
                    </RTLCol>
                    <RTLCol md={3} sm={24}>
                        {touched &&
                        ((error && <span className="errorMsg">{error}</span>) ||
                            (warning && <span className="warningMsg">{warning}</span>))}
                    </RTLCol>
                </RTLCol>
            </div>
        );
    }
}





